var path = 'areas/shared/views/selector/choice-role.html';
var html = "<div ng-bind-html=\"item | highlight: $select.search\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/choice-role.html
// module id = 605289768890304
// module chunks = 1